import React from "react";
import {
  Grid,
  Text,
  FontWeight,
  TextVariant,
} from "@pushpress/shared-components";

type PriceBreakdownLineProps = {
  label: string;
  value: string;
  variant?: TextVariant;
  weight?: FontWeight;
  description?: string;
};

function PriceBreakdownLine({
  label,
  value,
  description,
  variant = "body-lg",
  weight = "400",
}: PriceBreakdownLineProps) {
  return (
    <div className="mb-3">
      <Grid
        container
        item
        xs={12}
        alignItems="center"
        justifyContent="space-between"
      >
        <Text variant={variant} weight={weight}>
          {label}
        </Text>
        <Text variant={variant} color="wolf-800" weight={weight}>
          {value}
        </Text>
      </Grid>
      {description && (
        <Text variant={variant} color="wolf-500" className="mt-1">
          {description}
        </Text>
      )}
    </div>
  );
}

export default PriceBreakdownLine;
